import { Controller as TingwuController } from "@tingwu/core";

export class SphereContext {
  tingwuController: TingwuController;

  constructor(tingwuController: TingwuController) {
    this.tingwuController = tingwuController;
  }
}
